import { render, staticRenderFns } from "./CreateAttributePage.vue?vue&type=template&id=0f25f282&scoped=true"
import script from "./CreateAttributePage.vue?vue&type=script&lang=js"
export * from "./CreateAttributePage.vue?vue&type=script&lang=js"
import style0 from "./CreateAttributePage.vue?vue&type=style&index=0&id=0f25f282&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f25f282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f25f282')) {
      api.createRecord('0f25f282', component.options)
    } else {
      api.reload('0f25f282', component.options)
    }
    module.hot.accept("./CreateAttributePage.vue?vue&type=template&id=0f25f282&scoped=true", function () {
      api.rerender('0f25f282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/CreateAttributePage.vue"
export default component.exports